import { getAuth } from "firebase/auth";
import {
  child, get, getDatabase, onValue,
  orderByKey, push, query, ref, remove, update
} from "firebase/database";
import { now } from "moment";
import "../Firebase";

const auth = getAuth();

let db = getDatabase();
const dbRef = ref(getDatabase());
const teamsRef = ref(db, "teams");

export const createTeam = (team) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`))
    .then((snapshot) => {
      if (!snapshot.exists() || snapshot.val().teamId) {
        return false;
      }

      team.members = {};
      team.members[auth.currentUser.uid] = {
        title: team.position,
      };
      team.position = null;
      var teamId = push(child(dbRef, "teams"), team).key;
      update(ref(db, `users/${auth.currentUser.uid}`), {
        teamId: teamId,
      });
    })
    .catch((e) => {
      console.log(e);
      return false;
    });
};

export const isFull = async (teamId) => {
  let teamsSnap = await get(teamsRef);

  let teams = teamsSnap.val();
  let teamMembers = teams[teamId].member;
  let memberArr = [];
  for (const memberId in teamMembers) memberArr.push(teamMembers[memberId]);
  return memberArr.length === 5;
}

export const teamIdList = async () => {
  let result = [];
  let teamsSnap = await get(teamsRef);

  let teams = teamsSnap.val();
  for (const team_id in teams) result.push(team_id);
  return result;
}

export const teamList = async () => {
  let result = [];
  let teamsSnap = await get(teamsRef);

  let teams = teamsSnap.val();
  for (const team_id in teams) {
    if (Object.hasOwnProperty.call(teams, team_id)) {
      let team = teams[team_id];
      let teamMembers = team.members;
      let membersArr = [];
      for (const memberId in teamMembers) {
        if (Object.hasOwnProperty.call(teamMembers, memberId)) {
          let member = teamMembers[memberId];
          let usersRef = ref(db, `users/${memberId}`);
          onValue(usersRef, (userSnap) => {
            let user = userSnap.val();
            if (user) {
              member.name = user["username"];
              member.img = user["profile_picture"];
              member.id = memberId;
            }
          });
          membersArr.push(member);
        }
      }
      team.id = team_id;
      team.members = membersArr;
      result.push(team);
    }
  }

  return result;
};



export const allUserList = async () => {
  let snapshot = await get(ref(db, `users`));
  if (snapshot.exists()) {
    let result = []
    var users = snapshot.val();
    for (const user_id in users) {
      if (Object.hasOwnProperty.call(users, user_id)) {
        let user = users[user_id];
        result.push(
          {
          id: user_id,
          name: user.username,
          email: user.email,
          gender: user.gender,
          img: user.profile_picture,
          softPower: user.softPower,
          hardPower: user.hardPower,
          experience: user.experience,
          motivation: user.motivation,
          igLink: user.igLink,
          fbLink: user.fbLink,
          deeds: user.deeds,
          linkedInLink: user.linkedInLink,
          inTeam: user.teamId,
          }
        )
      }
    }
    return result;
  }
  return null;
}
export const userList = async () => {
  let result = [];
  let usersSnap = await get(ref(db, 'users'));
  let users = usersSnap.val();
  let teamIds = [];
  let teamsSnap = await get(teamsRef);

  let teams = teamsSnap.val();
  for (const team_id in teams) teamIds.push(team_id);
  for (const user_id in users) {
    if (Object.hasOwnProperty.call(users, user_id)) {
      let user = users[user_id];
      result.push(
        {
          id: user_id,
          name: user.username,
          img: user.profile_picture,
          motivation: user.motivation,
          igLink: user.igLink,
          fbLink: user.fbLink,
          linkedInLink: user.linkedInLink,
          inTeam: teamIds.includes(user.teamId)
        }
      );
    }
  }
  return result;
}

export const personalEvent = async () => {
  var result = [];
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snap) => {
    let user = snap.val();
    if (user.events) {
      for (const event_id in user.events) {
        let tmp = user.events[event_id];
        tmp.eventId = event_id;
        result.push(tmp);
      }
    }
  })
    .catch(console.log);
  return result;
}

export const applyPosition = (request) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`))
    .then((snapshot) => {
      if (!snapshot.exists() || snapshot.val().teamId) {
        return false;
      }
      let user = snapshot.val();
      let event = {};
      event = {
        position: request.position,
        type: "apply",
        applicant: user.username,
        time: now(),
        applicantId: auth.currentUser.uid,
        applicantImg: user.profile_picture,
      };
      return push(child(dbRef, `events/${request.id}`), event).key;
    })
    .catch((e) => {
      console.log(e);
      return false;
    });
};

export const inviteMember = (request) => {
  get(child(dbRef, `users/${request.uid}`))
    .then((snapshot) => {
      if (!snapshot.exists() || snapshot.val().teamId) {
        return false;
      }
      let user = snapshot.val();
      let userEvent = {};
      let teamEvent = {};
      teamEvent = {
        type: "invite",
        talent: user.username,
        talentId: request.uid,
        time: now(),
      };
      const teamEventId = push(
        child(dbRef, `events/${request.teamId}`),
        teamEvent
      ).key;
      userEvent = {
        type: "invite",
        position: request.position,
        teamName: request.teamName,
        teamId: request.teamId,
        teamField: request.teamField,
        teamDescription: request.teamDescription,
        teamEventId: teamEventId,
        time: now(),
      };
      return [
        teamEventId,
        push(child(dbRef, `users/${request.uid}/events`), userEvent).key,
      ];
    })
    .catch((e) => {
      console.log(e);
      return false;
    });
};

export const acceptInvitation = (teamId, position, teamEventId) => {
  // 1. add the user to the team
  update(
    child(dbRef, `teams/${teamId}/members/${auth.currentUser.uid}`),
    {
      title: position,
    }
  );
  // 2. add new team event
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((talentSnap) => {
    let talent = talentSnap.val();
    const event = {
      talentId: auth.currentUser.uid,
      talentName: talent.username,
      type: "accepted",
      time: now(),
    };
    remove(child(dbRef, `events/${teamId}/${teamEventId}`));
    push(child(dbRef, `events/${teamId}`), event);
    remove(child(dbRef, `users/${auth.currentUser.uid}/events`));
    update(child(dbRef, `users/${auth.currentUser.uid}`), {
      teamId: teamId,
    });
  })
};

export const rejectInvitation = (userEventId, teamId, teamEventId) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((rejecterSnap) => {
    let rejecter = rejecterSnap.val();
    const event = {
      rejecterId: auth.currentUser.uid,
      rejecterName: rejecter.username,
      type: "rejected",
      time: now(),
    };
    push(child(dbRef, `events/${teamId}`), event);
  });
  remove(child(dbRef, `users/${auth.currentUser.uid}/events/${userEventId}`));
  remove(child(dbRef, `events/${teamId}/${teamEventId}`));
};

export const removeInvitation = (userEventId, teamId, teamEventId) => {
  remove(child(dbRef, `users/${auth.currentUser.uid}/events/${userEventId}`));
  remove(child(dbRef, `events/${teamId}/${teamEventId}`));
};

export const eventList = async (id) => {
  let result = [];
  let eventQuery = query(child(dbRef, `events/${id}`), orderByKey());
  let events = (await get(eventQuery)).val();
  for (const key in events) {
    if (Object.hasOwnProperty.call(events, key)) {
      let event = events[key];
      event.id = key;
      result.push(event);
    }
  }
  return result;
};

export const rejectApplication = (eventId) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((rejecterSnap) => {
    let rejecter = rejecterSnap.val();
    remove(child(dbRef, `events/${rejecter.teamId}/${eventId}`));
  });
};

export const leaveTeam = () => {
  // let snapshot = await get(child(dbRef, `users/${auth.currentUser.uid}`));
  // if (!snapshot.exists() || !snapshot.val().teamId) {
  //   return false;
  // }
  // let user = snapshot.val();

  // remove(child(dbRef, `teams/${user.teamId}/members/${auth.currentUser.uid}`));
  // remove(child(dbRef, `users/${auth.currentUser.uid}/teamId`));
  // let memberSnap = await get(child(dbRef, `teams/${user.teamId}/members/`));
  // if (memberSnap.val() === null) {
  //   remove(child(dbRef, `teams/${user.teamId}/`));
  // }

  get(child(dbRef, `users/${auth.currentUser.uid}`))
    .then((snapshot) => {
      if (!snapshot.exists() || !snapshot.val().teamId) {
        return false;
      }
      let user = snapshot.val();

      remove(
        child(dbRef, `teams/${user.teamId}/members/${auth.currentUser.uid}`)
      );
      remove(child(dbRef, `users/${auth.currentUser.uid}/teamId`));
      get(child(dbRef, `teams/${user.teamId}/members/`)).then((memberSnap) => {
        if (memberSnap.val() === null) {
          remove(child(dbRef, `teams/${user.teamId}/`));
        }
      });
    })
    .catch((e) => {
      console.log(e);
      return false;
    });
};

export const allowJoin = async (eventId) => {
  let allower = (
    await get(child(dbRef, `users/${auth.currentUser.uid}`))
  ).val();
  let requestEvent = (
    await get(child(dbRef, `events/${allower.teamId}/${eventId}`))
  ).val();
  let members = (
    await get(child(dbRef, `teams/${allower.teamId}/members/`))
  ).val();
  let appliedTeam = (
    await get(child(dbRef, `users/${requestEvent.applicantId}/applyTeam`))
  ).val();

  if (appliedTeam) {
    for (const key in appliedTeam) {
      const teamId = key;
      if (teamId === allower.teamId) continue;
      const events = (await get(child(dbRef, `events/${teamId}/`))).val();
      for (const id in events) {
        if (
          events[id].applicantId === requestEvent.applicantId &&
          events[id].type === "apply"
        ) {
          remove(child(dbRef, `events/${teamId}/${id}`));
        }
      }
    }
    remove(child(dbRef, `users/${requestEvent.applicantId}/applyTeam`));
  }

  for (const memberId in members) {
    const member = members[memberId];
    if (!requestEvent || member.title === requestEvent.position) {
      return false;
    }
  }
  let event = {};
  event = {
    allower: allower.username,
    type: "allow",
    applicant: requestEvent.applicant,
    time: now(),
    applicantId: requestEvent.applicantId,
  };
  let newEventid = push(child(dbRef, `events/${allower.teamId}`), event).key;
  update(child(dbRef, `events/${allower.teamId}/${eventId}`), {
    type: "allowed",
  });
  update(child(dbRef, `users/${requestEvent.applicantId}`), {
    teamId: allower.teamId,
  });
  update(
    child(dbRef, `teams/${allower.teamId}/members/${requestEvent.applicantId}`),
    {
      title: requestEvent.position,
    }
  );
};

export const myTeam = async () => {
  let user = (await get(child(dbRef, `users/${auth.currentUser.uid}`))).val();
  if (!user) return null;
  let teamsSnap = await get(child(teamsRef, `${user.teamId}`));
  let team = teamsSnap.val();
  if (!team) return null;
  let teamMembers = team.members;
  let membersArr = [];
  for (const memberId in teamMembers) {
    if (Object.hasOwnProperty.call(teamMembers, memberId)) {
      let member = teamMembers[memberId];
      let usersRef = ref(db, `users/${memberId}`);
      onValue(usersRef, (userSnap) => {
        let user = userSnap.val();
        member.name = user.username;
        member.img = user["profile_picture"];
        member.id = memberId;
      });
      membersArr.push(member);
    }
  }
  team.id = teamsSnap.key;
  team.members = membersArr;
  return team;
};

